import { render } from "./AssinaturasTable.vue?vue&type=template&id=0b5631b0"
import script from "./AssinaturasTable.vue?vue&type=script&lang=js"
export * from "./AssinaturasTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__